import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashbordService {
  uri = localStorage.getItem('serverRoot');
  user = JSON.parse(sessionStorage.getItem('user'));

  constructor(private http: HttpClient) {
  }

  getProduits() {
    return this.http.get(`${this.uri}/admins/${this.user._id}/products`);
  }

  getCompanys() {
    return this.http.get(`${this.uri}/admins/${this.user._id}/companys`);
  }

  getOrders() {
    return this.http.get(`${this.uri}/admins/${this.user._id}/orders`);
    }
}
